import React, { useState } from "react";
import { Input } from "../../Helpers/Input/Input";
import PhoneInput from "react-phone-input-2";
import trans from "../../../utils";
import { InputSelect } from "../../Helpers/Input/RefactoredInput";
import { countries } from "../../../utils/CountryState/countries";
import { state } from "../../../utils/CountryState/states";

export default function CustomerLocation({ addData }) {
	const [location, setLocation] = useState({
		country: addData.values.country ? addData.values.country : null,
		city: addData.values.city ? addData.values.city : null,
	});

	const [stateId, setStateId] = useState();
	function capitalizeWords(str) {
		if (!str) return "";
		return str
			.split(" ")
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
			.join(" ");
	}
	const sanitizeForSQL = (str) => {
		// Allow only letters, numbers, spaces, and basic punctuation like hyphens
		return str.replace(/[^a-zA-Z0-9\s\-]/g, "");
	};
	return (
		<div className="userinfo mb-24">
			<p className="fs-16 fw-700 brand-700 text-uppercase">
				{trans("customer location")}
			</p>
			<div className="row">
				<div className="col-lg-12">
					<Input
						title={trans("address")}
						type="text"
						placeholder={trans("Ex. tahrir st, cairo")}
						formstyle="form-input"
						id="address"
						name="address"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.address}
						touched={addData.touched.address}
						value={addData.values.address || ""}
					/>
				</div>
				<div className="col-lg-6">
					<InputSelect
						label="Country"
						name="country"
						id="country"
						placeholder={trans("Select Country")}
						onBlur={addData.handleBlur}
						onChange={(value) => {
							addData.setFieldValue("country", value);
							setLocation({ country: value, state: null, city: null });
							setStateId(undefined); // reset stateId as country changed
							if (addData.values.state && addData.values.city) {
								addData.setFieldValue("state", null);
								addData.setFieldValue("city", null);
							}
						}}
						value={
							addData.values.country
								? capitalizeWords(addData.values.country)
								: undefined
						}
						touched={addData.touched.country}
						errors={addData.errors.country}
						options={countries?.map((i) => ({
							label: trans(i.name),
							value: i.name,
						}))}
						formstyle="form-input"
					/>
				</div>
				<div className="col-lg-6">
					<InputSelect
						label="City"
						name="city"
						id="city"
						placeholder={trans("Select City")}
						onBlur={addData.handleBlur}
						onChange={(value) => {
							addData.setFieldValue("city", value);
							const countryStates =
								state.find((s) => s.countryName === location.country)?.states ||
								state.find((s) => s.country === location.country)?.states;
							const selected = countryStates.find((i) => i.name === value);
							if (selected) {
								setStateId(selected.id);
								setLocation((prev) => ({ ...prev, city: value }));
							}
						}}
						value={
							addData.values.country && capitalizeWords(addData.values.city)
						}
						touched={addData.touched.city}
						errors={addData.errors.city}
						options={
							state
								.find(
									(i) =>
										i.countryName === location.country ||
										i.country === addData.values.country
								)
								?.states?.map((i) => ({
									label: trans(i.name),
									value: sanitizeForSQL(i.name),
								})) || []
						}
						formstyle="form-input"
					/>
				</div>
			</div>
		</div>
	);
}
